const isolationMetaName = "fergmar-outbound-isolation";
let isolationMarkup: string | undefined;

export function outboundIsolationMarkup(): string {
	return (isolationMarkup ??= `<meta name="${isolationMetaName}" content="denied"><script>(${installBrowserOutboundIsolation.toString()})(${JSON.stringify(isolationMetaName)})</script>`);
}

export function installBrowserOutboundIsolation(metaName = isolationMetaName): boolean {
	const marker = document.querySelector(`meta[name="${metaName}"]`);
	if (!marker) return false;
	if (marker.hasAttribute("data-installed")) return true;
	marker.setAttribute("data-installed", "true");
	const currentOrigin = window.location.origin;
	const internalTarget = (url: string | URL) => {
		try {
			return new URL(url, window.location.href).origin === currentOrigin;
		} catch {
			return false;
		}
	};
	const isolateAnchor = (anchor: Element) => {
		const href = anchor.getAttribute("href");
		if (href === null) return;
		if (internalTarget(href)) {
			anchor.removeAttribute("data-outbound-isolated");
			return;
		}
		anchor.removeAttribute("href");
		anchor.setAttribute("data-outbound-isolated", "true");
	};
	const isolateLinks = (root: Document | Element) => {
		if (root instanceof Element && root.localName === "a") isolateAnchor(root);
		root.querySelectorAll("a[href]").forEach(isolateAnchor);
	};
	isolateLinks(document);
	new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (
				mutation.type === "attributes" &&
				mutation.target instanceof Element &&
				mutation.target.localName === "a"
			)
				isolateAnchor(mutation.target);
			for (const node of mutation.addedNodes) if (node instanceof Element) isolateLinks(node);
		}
	}).observe(document.documentElement, {
		childList: true,
		subtree: true,
		attributes: true,
		attributeFilter: ["href"]
	});
	const preventExternalLink = (event: Event) => {
		const target = event.target instanceof Element ? event.target.closest("a") : null;
		if (!target) return;
		const href = target.getAttribute("href");
		if (
			!target.hasAttribute("data-outbound-isolated") &&
			(href === null || internalTarget(href))
		)
			return;
		event.preventDefault();
		event.stopImmediatePropagation();
	};
	document.addEventListener("click", preventExternalLink, true);
	document.addEventListener("auxclick", preventExternalLink, true);
	const open = window.open;
	window.open = (url, target, features) => {
		if (!url || !internalTarget(url)) return null;
		return open.call(window, url, target, features);
	};
	if ("navigation" in window) {
		window.navigation.addEventListener("navigate", (event) => {
			if (!internalTarget(event.destination.url)) event.preventDefault();
		});
	}
	return true;
}
